import { _ } from "../../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import KeyFigureListEditor from "../KeyFigureListEditor/KeyFigureListEditor.js";
import KeyFigurePresetFormWidget from "../KeyFigurePresetFormWidget.js";
import TabWidget from "../../TabWidget/TabWidget.js";

/**
 * `KeyFigurePresetSettingsWidget` renders different tabs to edit a
 * key figure preset: the meta-data as well as included key figures
 * can be edited. The key figure preset must be set with
 * `setKeyFigurePreset()`.
 *
 * @param {function} spec.updateCallback - Function called when the
 * user changes the key figure preset.
 * @param {function} spec.deleteCallback - Function called when the
 * user presses the delete button.
 */
export default class KeyFigurePresetSettingsWidget extends Widget {
	constructor({ updateCallback, deleteCallback } = {}) {
		super(...arguments);

		this._updateCallback = updateCallback;
		this._deleteCallback = deleteCallback;

		this._keyFigurePreset = undefined;

		this._keyFigurePresetForm = new KeyFigurePresetFormWidget({
			updateCallback: this._updateCallback,
			deleteCallback: this._deleteCallback,
		});

		this._keyFigureListEditor = new KeyFigureListEditor({
			updateCallback: (keyFigures) => {
				this._keyFigurePreset.setKeyFigures(keyFigures);
				this._updateCallback();
			},
		});

		this._tabsWidget = new TabWidget({
			tabs: [
				{
					name: _("Preset Info"),
					id: "tab-preset-info",
					content: this._keyFigurePresetForm,
				},
				{
					name: _("Preset KPIs"),
					dataTestName: "tab-keyfigures",
					content: this._keyFigureListEditor,
				},
			],
			tabsOnlyOnMobile: true,
		});
	}

	setup({ keyFigurePreset, allKeyFigures = [] }) {
		this._keyFigurePreset = keyFigurePreset;
		this._keyFigurePresetForm.setKeyFigurePreset(keyFigurePreset);

		this._keyFigureListEditor.setup({
			myKeyFigures: keyFigurePreset.getKeyFigures(),
			allKeyFigures,
		});
	}

	renderContentOn(html) {
		if (!this._keyFigurePreset) {
			return;
		}

		html.render(this._tabsWidget);
	}
}
